export enum PageRedirect {
  Home = 1,
  Dashboard = 2,
  Restaurant = 3,
  HotelDashboard = 4,
  Umbrella = 5,
}

export const resolvePageRedirectRoute = (pageRedirect?: number | string | null) => {
  const normalized = Number(pageRedirect ?? PageRedirect.Dashboard);

  switch (normalized) {
    case PageRedirect.Home:
      return '/home';
    case PageRedirect.Restaurant:
      return '/restaurant';
    case PageRedirect.HotelDashboard:
      return '/hotel-dashboard';
    case PageRedirect.Umbrella:
      return '/umbs';
    case PageRedirect.Dashboard:
    default:
      return '/dashboard-restaurant';
  }
};

export const pageRedirectOptions = [
  { id: PageRedirect.Home, name: 'Home' },
  { id: PageRedirect.Dashboard, name: 'Dashboard' },
  { id: PageRedirect.Restaurant, name: 'Restaurant' },
  { id: PageRedirect.HotelDashboard, name: 'Hotel Dashboard' },
  { id: PageRedirect.Umbrella, name: 'Umbrella' },
];
